import React, { memo, useMemo } from 'react';
import SectionHeader from 'features/invest/components/SectionHeader';
import RowTransaction from 'features/transactions/components/RowTransaction';
import { View } from 'react-native';
import createStyleSheets from 'utils/createStyleSheets';
import { rem } from 'design-system';
import useStyles from 'hooks/useStyles';
const TransactionPreviewRow = ({ item, onPress, isEditingTransactions, isMultipleSelect, selected, }) => {
    const styles = useStyles(styleSet);
    const borderStyles = useMemo(() => [
        item.isLastInSection && styles.lastItem,
        item.isFirstInSection && styles.firstItem,
    ], [
        item.isLastInSection,
        item.isFirstInSection,
        styles.lastItem,
        styles.firstItem,
    ]);
    if ('sectionTitle' in item) {
        return <SectionHeader title={item.sectionTitle} style={styles.header}/>;
    }
    return (<View style={[styles.wrapper, borderStyles]}>
      <RowTransaction item={item} backgroundDark onPress={onPress} btnStyles={borderStyles} isEditingTransactions={isEditingTransactions} isMultipleSelect={isMultipleSelect} selected={selected}/>
    </View>);
};
export default memo(TransactionPreviewRow);
const styleSet = createStyleSheets((colors) => ({
    header: {
        marginTop: rem(16),
    },
    wrapper: {
        marginHorizontal: rem(16),
        backgroundColor: colors.cards.onDark,
    },
    firstItem: {
        borderTopLeftRadius: rem(16),
        borderTopRightRadius: rem(16),
    },
    lastItem: {
        borderBottomLeftRadius: rem(16),
        borderBottomRightRadius: rem(16),
    },
}));
